import React from 'react';
import { CONTACT } from '../../data/portfolio';
import type { ViewName } from '../../types';

const VIEWS: { id: ViewName; label: string }[] = [
  { id: 'now', label: 'now' },
  { id: 'projects', label: 'projects' },
  { id: 'experience', label: 'experience' },
  { id: 'education', label: 'education' },
  { id: 'research', label: 'research' },
  { id: 'blogs', label: 'blogs' },
  { id: 'about', label: 'about' },
];

interface RailProps {
  current: ViewName;
  onGo: (name: ViewName) => void;
}

const Rail: React.FC<RailProps> = ({ current, onGo }) => (
  <nav className="rail" aria-label="Primary">
    <div className="mark">
      SC<i />
    </div>
    <div className="nav">
      {VIEWS.map((v) => (
        <button
          key={v.id}
          type="button"
          data-go={v.id}
          aria-current={current === v.id ? 'true' : undefined}
          onClick={() => onGo(v.id)}
        >
          {v.label}
        </button>
      ))}
    </div>
    <div className="social">
      <a href={`mailto:${CONTACT.email}`}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="m3 7 9 6 9-6" />
        </svg>
        <span>email</span>
      </a>
      <a href={CONTACT.github} target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.9a3.4 3.4 0 0 0-.9-2.6c3-.3 6.2-1.5 6.2-6.7A5.2 5.2 0 0 0 19.9 5a4.9 4.9 0 0 0-.1-3.6s-1.1-.3-3.7 1.4a12.7 12.7 0 0 0-6.7 0C6.8 1.1 5.7 1.4 5.7 1.4A4.9 4.9 0 0 0 5.6 5a5.2 5.2 0 0 0-1.4 3.6c0 5.2 3.1 6.4 6.1 6.7a3.4 3.4 0 0 0-.9 2.6V22" />
        </svg>
        <span>github</span>
      </a>
      <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="2" y="2" width="20" height="20" rx="2" />
          <path d="M7 10v7M7 7v.01M11.5 17v-4a2.5 2.5 0 0 1 5 0v4" />
        </svg>
        <span>linkedin</span>
      </a>
      <a href={CONTACT.resume} download>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
        </svg>
        <span>resume</span>
      </a>
    </div>
  </nav>
);

export default Rail;
